import { useRef, useState } from "react";

export function useCopy(): [string | null, (text: string, key?: string) => void] {
  const [copied, setCopied] = useState<string | null>(null);
  const tRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const copy = (text: string, key?: string) => {
    try {
      navigator.clipboard?.writeText(text);
    } catch (_e) { /* no-op in sandbox */ }
    setCopied(key ?? text);
    clearTimeout(tRef.current);
    tRef.current = setTimeout(() => setCopied(null), 1100);
  };

  return [copied, copy];
}
